var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"dropdown-list",class:{
	show: _vm.show,
}},[_c('div',{staticClass:"list"},[_vm._t("default")],2),(_vm.hasContent)?_c('div',{staticClass:"dropdown-content"},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }